import {
  numberToInt1ygmcfwhs2fkq as numberToInt,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  copyOfgossjg6lh6js as copyOf,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Unit_instanceat14thlj150z as Unit_instance,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  Char__compareTo_impl_ypi4mb252jweqlvw9s as Char__compareTo_impl_ypi4mb,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString14fd7g605f91p as toString,
  ArrayList3it5z8td81qkl as ArrayList,
  toList2enan2cfix0ie as toList,
  toString1pkumu07cwy4m as toString_0,
  toString30pk9tzaqopn as toString_1,
  isNumberiramasdbon0i as isNumber,
  Enum3alwj03lh1n41 as Enum,
  Iterable1y3qizuf89iou as Iterable,
  KtMap140uvy3s5zad8 as KtMap,
  toList3jhuyej2anx2q as toList_0,
  numberToChar93r9buh19yek as numberToChar,
  RuntimeException1r3t0zl97011n as RuntimeException,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  equals2v6cggk171b6e as equals_0,
  emptyList1g2z5xcrvp2zy as emptyList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  trimStart5ewg8zf6cs5u as trimStart,
  trim11nh7r46at6sx as trim,
  hashCodeq5arwsb9dgti as hashCode,
  sorted354mfsiv4s7x5 as sorted,
  reversed22y3au42jl32b as reversed,
  distinct10qe1scfdvu5k as distinct,
  copyToArray2j022khrow2yi as copyToArray,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  endsWith1a79dp5rc3sfv as endsWith,
  startsWith38d3sbg25w0lx as startsWith,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  startsWith26w8qjqapeeq6 as startsWith_0,
  substringAfter1hku067gwr5ve as substringAfter,
  contains2el4s70rdq4ld as contains,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  firstOrNull1982767dljvdy as firstOrNull,
  println2shhhgwwt4c61 as println,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  joinToStringxqcavsxcmh4q as joinToString,
  Char19o2r8palgjof as Char,
  linkedMapOf1is69t4zkcfr3 as linkedMapOf,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull,
  startsWith1bgirhbedtv2y as startsWith_1,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Regexxgw0gjiagf4z as Regex,
  sequence2vgswtrxvqoa7 as sequence,
  joinToString1cxrrlmo0chqs as joinToString_0,
  toList2zksu85ukrmi as toList_1,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  toIntOrNull3w2d066r9pvwm as toIntOrNull_0,
  Paire9pteg33gng7 as Pair,
  createThis2j2avj17cvnv2 as createThis,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  addAll1k27qatfgp3k5 as addAll,
} from './kotlin-kotlin-stdlib.mjs';
import {
  DoubleList2honu8rif2roh as DoubleList,
  getAt237u54ctbxwvd as getAt,
  listIterator247sl90ooi4qv as listIterator,
  listIterator1a2ckgeamf7jc as listIterator_0,
  subList28p829u9d5w23 as subList,
  containsteg8664aaglk as contains_0,
  containsAll1oa5i6t9xmbdv as containsAll,
  isEmptyrqh4vz39e0v6 as isEmpty,
  iterator300ls4j24zqzz as iterator,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NumberParser_getInstance79qhb9yu73eu as NumberParser_getInstance,
  ctypeAsInt3q5txwwtaj9c8 as ctypeAsInt,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  Companion_instancem01nsetwb8p0 as Companion_instance,
  Companion_instance26d85glythbe0 as Companion_instance_0,
  get_eofrk1bzx8ckgtd as get_eof,
  readUntilBuilderazvgts3bogti as readUntilBuilder,
  isWhitespaceFast2iszcfvpi3biz as isWhitespaceFast,
  skipExpect1tagjz9aj6y5q as skipExpect,
  skipSpaces25iogcdi8m3q2 as skipSpaces,
  tryExpect2a3h5rf36r8u1 as tryExpect,
  matchIdentifier3b7zgfy94bf8r as matchIdentifier,
  matchSingleOrDoubleQuoteString398sq4vhn9fz as matchSingleOrDoubleQuoteString,
} from './korlibs-string-root-korlibs-string.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Json {
  constructor() {
    Companion_getInstance();
    this.e1k_1 = false;
  }
  f1k(s) {
    return this.g1k(Companion_instance.a1i(s));
  }
  h1k(obj, pretty) {
    var tmp;
    if (pretty) {
      // Inline function 'kotlin.apply' call
      var this_0 = Companion_instance_0.q1h();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.stringify.<anonymous>' call
      this.n1k(obj, this_0);
      tmp = this_0.toString();
    } else {
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.f();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.stringify.<anonymous>' call
      this.i1k(obj, this_1);
      tmp = this_1.toString();
    }
    return tmp;
  }
  j1k() {
    return this.e1k_1;
  }
  k1k(capacity) {
    return ArrayList.w(capacity);
  }
  l1k(capacity, $super) {
    capacity = capacity === VOID ? 16 : capacity;
    return $super === VOID ? this.k1k(capacity) : $super.k1k.call(this, capacity);
  }
  m1k(doubles) {
    return toList(doubles.t1i());
  }
  g1k(s) {
    var ic = skipSpaces_0(s, this).r1h();
    var tmp;
    if (ic === _Char___init__impl__6a9atx(123)) {
      tmp = parseObject(this, s);
    } else if (ic === _Char___init__impl__6a9atx(91)) {
      tmp = parseArray(this, s);
    } else if (ic === _Char___init__impl__6a9atx(45) || (ic === _Char___init__impl__6a9atx(43) || ic === _Char___init__impl__6a9atx(48)) || (ic === _Char___init__impl__6a9atx(49) || (ic === _Char___init__impl__6a9atx(50) || ic === _Char___init__impl__6a9atx(51))) || (ic === _Char___init__impl__6a9atx(52) || (ic === _Char___init__impl__6a9atx(53) || ic === _Char___init__impl__6a9atx(54)) || (ic === _Char___init__impl__6a9atx(55) || (ic === _Char___init__impl__6a9atx(56) || ic === _Char___init__impl__6a9atx(57))))) {
      var dres = parseNumber(this, s);
      tmp = numberToInt(dres) === dres ? numberToInt(dres) : dres;
    } else if (ic === _Char___init__impl__6a9atx(116)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'true');
      tmp = true;
    } else if (ic === _Char___init__impl__6a9atx(102)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'false');
      tmp = false;
    } else if (ic === _Char___init__impl__6a9atx(110)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'null');
      tmp = null;
    } else if (ic === _Char___init__impl__6a9atx(117)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'undefined');
      tmp = null;
    } else if (ic === _Char___init__impl__6a9atx(34)) {
      tmp = this.p1k(s).toString();
    } else {
      invalidJson(this, "Not expected '" + toString(ic) + "' in " + toString_0(s));
    }
    return tmp;
  }
  i1k(obj, b) {
    if (obj == null)
      b.nb('null');
    else {
      if (!(obj == null) ? typeof obj === 'boolean' : false)
        b.nb(obj ? 'true' : 'false');
      else {
        if (!(obj == null) ? isInterface(obj, KtMap) : false) {
          b.ob(_Char___init__impl__6a9atx(123));
          var iterator = obj.m1().a1();
          var index = 0;
          while (iterator.b1()) {
            var i = index;
            index = index + 1 | 0;
            var v = iterator.c1();
            if (!(i === 0)) {
              b.ob(_Char___init__impl__6a9atx(44));
            }
            this.i1k(v.n1(), b);
            b.ob(_Char___init__impl__6a9atx(58));
            this.i1k(v.o1(), b);
          }
          b.ob(_Char___init__impl__6a9atx(125));
        } else {
          if (!(obj == null) ? isInterface(obj, Iterable) : false) {
            b.ob(_Char___init__impl__6a9atx(91));
            var iterator_0 = obj.a1();
            var index_0 = 0;
            while (iterator_0.b1()) {
              var i_0 = index_0;
              index_0 = index_0 + 1 | 0;
              var v_0 = iterator_0.c1();
              if (!(i_0 === 0)) {
                b.ob(_Char___init__impl__6a9atx(44));
              }
              this.i1k(v_0, b);
            }
            b.ob(_Char___init__impl__6a9atx(93));
          } else {
            if (obj instanceof Enum) {
              encodeString_0(this, obj.j3_1, b);
            } else {
              if (!(obj == null) ? typeof obj === 'string' : false) {
                encodeString_0(this, obj, b);
              } else {
                if (isNumber(obj))
                  b.nb(toString_0(obj));
                else {
                  if (!(obj == null) ? isInterface(obj, CustomSerializer) : false) {
                    obj.u1k(b);
                  } else {
                    throw IllegalArgumentException.l("Don't know how to serialize " + toString_1(obj));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  n1k(obj, b) {
    if (obj == null)
      b.l1h('null');
    else {
      if (!(obj == null) ? typeof obj === 'boolean' : false)
        b.l1h(obj ? 'true' : 'false');
      else {
        if (!(obj == null) ? isInterface(obj, KtMap) : false) {
          b.m1h('{');
          $l$block: {
            // Inline function 'korlibs.util.indent' call
            b.n1h();
            try {
              var entries = obj.m1();
              var iterator = entries.a1();
              var index = 0;
              while (iterator.b1()) {
                var i = index;
                index = index + 1 | 0;
                var v = iterator.c1();
                if (!(i === 0)) {
                  b.m1h(',');
                }
                b.l1h(encodeString(this, '' + toString_1(v.n1())));
                b.l1h(': ');
                this.n1k(v.o1(), b);
                if (i === (entries.d1() - 1 | 0)) {
                  b.m1h('');
                }
              }
              break $l$block;
            }finally {
              b.o1h();
            }
          }
          b.l1h('}');
        } else {
          if (!(obj == null) ? isInterface(obj, Iterable) : false) {
            b.m1h('[');
            $l$block_0: {
              // Inline function 'korlibs.util.indent' call
              b.n1h();
              try {
                var entries_0 = toList_0(obj);
                var iterator_0 = entries_0.a1();
                var index_0 = 0;
                while (iterator_0.b1()) {
                  var i_0 = index_0;
                  index_0 = index_0 + 1 | 0;
                  var v_0 = iterator_0.c1();
                  if (!(i_0 === 0)) {
                    b.m1h(',');
                  }
                  this.n1k(v_0, b);
                  if (i_0 === (entries_0.d1() - 1 | 0)) {
                    b.m1h('');
                  }
                }
                break $l$block_0;
              }finally {
                b.o1h();
              }
            }
            b.l1h(']');
          } else {
            if (!(obj == null) ? typeof obj === 'string' : false)
              b.l1h(encodeString(this, obj));
            else {
              if (isNumber(obj))
                b.l1h(toString_0(obj));
              else {
                if (!(obj == null) ? isInterface(obj, CustomSerializer) : false) {
                  // Inline function 'kotlin.apply' call
                  var this_0 = StringBuilder.f();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.io.serialization.json.Json.stringifyPretty.<anonymous>' call
                  obj.u1k(this_0);
                  b.l1h(this_0.toString());
                } else {
                  throw IllegalArgumentException.l("Don't know how to serialize " + toString_1(obj));
                }
              }
            }
          }
        }
      }
    }
  }
  o1k(_this__u8e3s4, reportErrors, out) {
    var quotec = _this__u8e3s4.s1h();
    if (quotec !== _Char___init__impl__6a9atx(34) && quotec !== _Char___init__impl__6a9atx(39))
      throw IllegalArgumentException.l('Invalid string literal');
    var closed = false;
    loop: while (_this__u8e3s4.s1g()) {
      var c = _this__u8e3s4.s1h();
      if (c === _Char___init__impl__6a9atx(92)) {
        var cc = _this__u8e3s4.s1h();
        var tmp;
        if (cc === _Char___init__impl__6a9atx(92)) {
          tmp = _Char___init__impl__6a9atx(92);
        } else if (cc === _Char___init__impl__6a9atx(47)) {
          tmp = _Char___init__impl__6a9atx(47);
        } else if (cc === _Char___init__impl__6a9atx(39)) {
          tmp = _Char___init__impl__6a9atx(39);
        } else if (cc === _Char___init__impl__6a9atx(34)) {
          tmp = _Char___init__impl__6a9atx(34);
        } else if (cc === _Char___init__impl__6a9atx(98)) {
          tmp = _Char___init__impl__6a9atx(8);
        } else if (cc === _Char___init__impl__6a9atx(102)) {
          tmp = _Char___init__impl__6a9atx(12);
        } else if (cc === _Char___init__impl__6a9atx(110)) {
          tmp = _Char___init__impl__6a9atx(10);
        } else if (cc === _Char___init__impl__6a9atx(114)) {
          tmp = _Char___init__impl__6a9atx(13);
        } else if (cc === _Char___init__impl__6a9atx(116)) {
          tmp = _Char___init__impl__6a9atx(9);
        } else if (cc === _Char___init__impl__6a9atx(117)) {
          // Inline function 'korlibs.io.util.NumberParser.parseInt' call
          NumberParser_getInstance();
          var positive = true;
          var out_0 = 0;
          var n = 0;
          $l$loop_0: while (true) {
            // Inline function 'korlibs.io.serialization.json.Json.readStringLit.<anonymous>' call
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            var c_0 = _unary__edvuaz >= 4 ? _Char___init__impl__6a9atx(0) : _this__u8e3s4.s1h();
            if (c_0 === _Char___init__impl__6a9atx(0))
              break $l$loop_0;
            if (c_0 === _Char___init__impl__6a9atx(45) || c_0 === _Char___init__impl__6a9atx(43)) {
              positive = c_0 === _Char___init__impl__6a9atx(43);
            } else {
              var value = ctypeAsInt(c_0);
              if (value < 0)
                break $l$loop_0;
              out_0 = imul(out_0, 16);
              out_0 = out_0 + value | 0;
            }
          }
          var tmp$ret$1 = positive ? out_0 : -out_0 | 0;
          tmp = numberToChar(tmp$ret$1);
        } else {
          throw IllegalArgumentException.l("Invalid char '" + toString(cc) + "'");
        }
        var c_1 = tmp;
        out.ob(c_1);
      } else if (c === quotec) {
        closed = true;
        break loop;
      } else
        out.ob(c);
    }
    if (!closed && reportErrors) {
      throw RuntimeException.ia("String literal not closed! '" + toString_0(_this__u8e3s4) + "'");
    }
    return out;
  }
  p1k(_this__u8e3s4, reportErrors, out, $super) {
    reportErrors = reportErrors === VOID ? true : reportErrors;
    out = out === VOID ? StringBuilder.f() : out;
    return $super === VOID ? this.o1k(_this__u8e3s4, reportErrors, out) : $super.o1k.call(this, _this__u8e3s4, reportErrors, out);
  }
}
class Companion extends Json {
  constructor() {
    Companion_instance_1 = null;
    super();
    Companion_instance_1 = this;
  }
}
class MiniNumberArrayList {
  constructor() {
    this.q1k_1 = 0;
    this.r1k_1 = new Float64Array(16);
  }
  d1() {
    return this.q1k_1;
  }
  s1k() {
    return this.r1k_1.length;
  }
  f1(index) {
    return this.r1k_1[index];
  }
  t1k(value) {
    if (this.q1k_1 >= this.s1k()) {
      this.r1k_1 = copyOf(this.r1k_1, imul(this.r1k_1.length, 3));
    }
    var tmp = this.r1k_1;
    var _unary__edvuaz = this.q1k_1;
    this.q1k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = value;
  }
  t1i() {
    return copyOf(this.r1k_1, this.q1k_1);
  }
  u1i() {
    // Inline function 'kotlin.also' call
    var this_0 = new MiniNumberArrayList();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.clone.<anonymous>' call
    this_0.q1k_1 = this.q1k_1;
    var tmp = this_0;
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r1k_1 = this.r1k_1.slice();
    return this_0;
  }
  equals(other) {
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    if (!(other.d1() === this.q1k_1))
      return false;
    if (isInterface(other, DoubleList)) {
      var inductionVariable = 0;
      var last = this.q1k_1;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.f1(n) === other.f1(n)))
            return false;
        }
         while (inductionVariable < last);
      return true;
    }
    if (isInterface(other, KtList)) {
      var inductionVariable_0 = 0;
      var last_0 = this.q1k_1;
      if (inductionVariable_0 < last_0)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!equals(this.f1(n_0), other.f1(n_0)))
            return false;
        }
         while (inductionVariable_0 < last_0);
      return true;
    }
    var n_1 = 0;
    var _iterator__ex2g4s = other.a1();
    while (_iterator__ex2g4s.b1()) {
      var v = _iterator__ex2g4s.c1();
      var _unary__edvuaz = n_1;
      n_1 = _unary__edvuaz + 1 | 0;
      if (!equals(this.f1(_unary__edvuaz), v))
        return false;
    }
    return true;
  }
  hashCode() {
    return contentHashCode(this.r1k_1, this, 0, this.q1k_1);
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.sb(2 + imul(5, this.q1k_1) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.toString.<anonymous>' call
    this_0.ob(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.q1k_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.nb(', ');
        }
        var v = this.s1i(n);
        if (numberToInt(v) === v)
          this_0.qg(numberToInt(v));
        else
          this_0.tg(v);
      }
       while (inductionVariable < last);
    this_0.ob(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
  k1(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.v1i((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  t2(elements) {
    return this.w1i(elements);
  }
}
class CustomSerializer {}
class Xml$Companion$parse$Level {
  constructor(children, close) {
    this.v1k_1 = children;
    this.w1k_1 = close;
  }
  toString() {
    return 'Level(children=' + toString_0(this.v1k_1) + ', close=' + toString_1(this.w1k_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.v1k_1);
    result = imul(result, 31) + (this.w1k_1 == null ? 0 : this.w1k_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml$Companion$parse$Level))
      return false;
    var tmp0_other_with_cast = other instanceof Xml$Companion$parse$Level ? other : THROW_CCE();
    if (!equals(this.v1k_1, tmp0_other_with_cast.v1k_1))
      return false;
    if (!equals(this.w1k_1, tmp0_other_with_cast.w1k_1))
      return false;
    return true;
  }
}
class Companion_0 {
  v1l(lits) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(lits.length);
    var inductionVariable = 0;
    var last = lits.length;
    while (inductionVariable < last) {
      var item = lits[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.io.serialization.xml.Companion.fromList.<anonymous>' call
      var tmp$ret$0 = item.length;
      destination.h(tmp$ret$0);
    }
    var this_0 = distinct(reversed(sorted(destination)));
    var lengths = copyToArray(this_0);
    // Inline function 'kotlin.collections.linkedMapOf' call
    var map = LinkedHashMap.ac();
    // Inline function 'korlibs.io.serialization.xml.fastForEach' call
    var n = 0;
    while (n < lits.length) {
      // Inline function 'korlibs.io.serialization.xml.Companion.fromList.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = lits[_unary__edvuaz];
      map.f3(key, true);
    }
    return new Literals(lits, map, lengths);
  }
}
class Element {}
class ProcessingInstructionTag extends Element {
  constructor(name, attributes) {
    super();
    this.w1l_1 = name;
    this.x1l_1 = attributes;
  }
  toString() {
    return 'ProcessingInstructionTag(name=' + this.w1l_1 + ', attributes=' + toString_0(this.x1l_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.w1l_1);
    result = imul(result, 31) + hashCode(this.x1l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessingInstructionTag))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessingInstructionTag ? other : THROW_CCE();
    if (!(this.w1l_1 === tmp0_other_with_cast.w1l_1))
      return false;
    if (!equals(this.x1l_1, tmp0_other_with_cast.x1l_1))
      return false;
    return true;
  }
}
class OpenCloseTag extends Element {
  constructor(name, attributes) {
    super();
    this.a1l_1 = name;
    this.b1l_1 = attributes;
  }
  toString() {
    return 'OpenCloseTag(name=' + this.a1l_1 + ', attributes=' + toString_0(this.b1l_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a1l_1);
    result = imul(result, 31) + hashCode(this.b1l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenCloseTag))
      return false;
    var tmp0_other_with_cast = other instanceof OpenCloseTag ? other : THROW_CCE();
    if (!(this.a1l_1 === tmp0_other_with_cast.a1l_1))
      return false;
    if (!equals(this.b1l_1, tmp0_other_with_cast.b1l_1))
      return false;
    return true;
  }
}
class OpenTag extends Element {
  constructor(name, attributes) {
    super();
    this.y1k_1 = name;
    this.z1k_1 = attributes;
  }
  toString() {
    return 'OpenTag(name=' + this.y1k_1 + ', attributes=' + toString_0(this.z1k_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.y1k_1);
    result = imul(result, 31) + hashCode(this.z1k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenTag))
      return false;
    var tmp0_other_with_cast = other instanceof OpenTag ? other : THROW_CCE();
    if (!(this.y1k_1 === tmp0_other_with_cast.y1k_1))
      return false;
    if (!equals(this.z1k_1, tmp0_other_with_cast.z1k_1))
      return false;
    return true;
  }
}
class CommentTag extends Element {
  constructor(text) {
    super();
    this.l1l_1 = text;
  }
  toString() {
    return 'CommentTag(text=' + this.l1l_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.l1l_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CommentTag))
      return false;
    var tmp0_other_with_cast = other instanceof CommentTag ? other : THROW_CCE();
    if (!(this.l1l_1 === tmp0_other_with_cast.l1l_1))
      return false;
    return true;
  }
}
class CloseTag extends Element {
  constructor(name) {
    super();
    this.x1k_1 = name;
  }
  toString() {
    return 'CloseTag(name=' + this.x1k_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.x1k_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseTag))
      return false;
    var tmp0_other_with_cast = other instanceof CloseTag ? other : THROW_CCE();
    if (!(this.x1k_1 === tmp0_other_with_cast.x1k_1))
      return false;
    return true;
  }
}
class Text extends Element {
  constructor(text, cdata) {
    cdata = cdata === VOID ? false : cdata;
    super();
    this.h1l_1 = text;
    this.i1l_1 = cdata;
  }
  toString() {
    return 'Text(text=' + this.h1l_1 + ', cdata=' + this.i1l_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.h1l_1);
    result = imul(result, 31) + getBooleanHashCode(this.i1l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Text))
      return false;
    var tmp0_other_with_cast = other instanceof Text ? other : THROW_CCE();
    if (!(this.h1l_1 === tmp0_other_with_cast.h1l_1))
      return false;
    if (!(this.i1l_1 === tmp0_other_with_cast.i1l_1))
      return false;
    return true;
  }
}
class Xml$Stream$xmlSequence$slambda {
  constructor($r, $collapseSpaces, $processNamespaces) {
    this.y1l_1 = $r;
    this.z1l_1 = $collapseSpaces;
    this.a1m_1 = $processNamespaces;
  }
  g1m($this$sequence, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$sequence), $completion);
  }
  pd(p1, $completion) {
    return this.g1m(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_1 {
  constructor() {
    this.c1l_1 = '_raw_';
    this.d1l_1 = '_text_';
    this.e1l_1 = '_cdata_';
    this.f1l_1 = '_comment_';
  }
  g1l(tagName, attributes, children) {
    var tmp = Type_NODE_getInstance();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = LinkedHashMap.ac();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = attributes.m1().a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.io.serialization.xml.Companion.Tag.<anonymous>' call
      if (!(element.o1() == null)) {
        destination.f3(element.n1(), element.o1());
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(destination.d1());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = destination.m1().a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'korlibs.io.serialization.xml.Companion.Tag.<anonymous>' call
      var tmp$ret$5 = to(item.n1(), toString_1(item.o1()));
      destination_0.h(tmp$ret$5);
    }
    return new Xml(tmp, tagName, toMap(destination_0), children, '');
  }
  j1l(text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap.ac();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_text_', tmp_0, tmp$ret$0, text);
  }
  k1l(text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap.ac();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_cdata_', tmp_0, tmp$ret$0, text);
  }
  m1l(text) {
    var tmp = Type_COMMENT_getInstance();
    var tmp_0 = LinkedHashMap.ac();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_comment_', tmp_0, tmp$ret$0, text);
  }
  h1m(str, collapseSpaces, processNamespaces) {
    try {
      var stream = Stream_getInstance().i1m(str, collapseSpaces, processNamespaces).a1();
      var children = parse$level(stream).v1k_1;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = children.a1();
        while (tmp0_iterator.b1()) {
          var element = tmp0_iterator.c1();
          // Inline function 'korlibs.io.serialization.xml.Companion.parse.<anonymous>' call
          if (element.n1l_1.equals(Type_NODE_getInstance())) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$1;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(children) : tmp0_elvis_lhs;
      return tmp1_elvis_lhs == null ? Companion_instance_3.j1l('') : tmp1_elvis_lhs;
    } catch ($p) {
      if ($p instanceof NoSuchElementException) {
        var t = $p;
        println('ERROR: XML: ' + str + ' thrown a NoSuchElementException');
        return Companion_instance_3.j1l('!!ERRORED!!');
      } else {
        throw $p;
      }
    }
  }
}
class Type extends Enum {}
class Literals {
  constructor(lits, map, lengths) {
    this.j1m_1 = lits;
    this.k1m_1 = map;
    this.l1m_1 = lengths;
  }
  toString() {
    return 'Literals(' + joinToString(this.j1m_1, ' ') + ')';
  }
}
class Entities {
  constructor() {
    Entities_instance = this;
    this.c1m_1 = linkedMapOf([to(new Char(_Char___init__impl__6a9atx(34)), '&quot;'), to(new Char(_Char___init__impl__6a9atx(39)), '&apos;'), to(new Char(_Char___init__impl__6a9atx(60)), '&lt;'), to(new Char(_Char___init__impl__6a9atx(62)), '&gt;'), to(new Char(_Char___init__impl__6a9atx(38)), '&amp;')]);
    var tmp = this;
    var tmp_0 = Companion_instance_2;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.c1m_1.i3();
    var tmp$ret$0 = copyToArray(this_0);
    tmp.d1m_1 = tmp_0.v1l(tmp$ret$0);
    this.e1m_1 = flip(this.c1m_1);
  }
  m1m(str) {
    // Inline function 'korlibs.io.serialization.xml.eachBuilder' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.xml.eachBuilder.<anonymous>' call
    var inductionVariable = 0;
    var last = str.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.io.serialization.xml.Entities.encode.<anonymous>' call
        var it = charSequenceGet(str, n);
        var entry = Entities_getInstance().c1m_1.d3(new Char(it));
        if (!(entry == null))
          this_0.nb(entry);
        else
          this_0.ob(it);
      }
       while (inductionVariable < last);
    return this_0.toString();
  }
  f1m(str) {
    return this.n1m(Companion_instance.a1i(str));
  }
  n1m(r) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.xml.Entities.decode.<anonymous>' call
    var sb = StringBuilder.f();
    $l$loop: while (!get_eof(r)) {
      this_0.g(readUntilBuilder(r, _Char___init__impl__6a9atx(38), sb.xg()));
      if (get_eof(r))
        break $l$loop;
      skipExpect(r, _Char___init__impl__6a9atx(38));
      var value = readUntilBuilder(r, _Char___init__impl__6a9atx(59), sb.xg(), true);
      var full = '&' + value.toString();
      if (startsWith_1(value, _Char___init__impl__6a9atx(35))) {
        var base = 10;
        var str = value.vg(1, value.a() - 1 | 0);
        if (startsWith_0(str, 'x')) {
          base = 16;
          // Inline function 'kotlin.text.substring' call
          // Inline function 'kotlin.js.asDynamic' call
          str = str.substring(1);
        }
        var tmp42_safe_receiver = toIntOrNull(str, base);
        var tmp = tmp42_safe_receiver == null ? null : numberToChar(tmp42_safe_receiver);
        this_0.mb(tmp == null ? null : new Char(tmp));
      } else {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_1 = Entities_getInstance().e1m_1;
        if ((isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).b3(full))
          this_0.mb(Entities_getInstance().e1m_1.d3(full));
        else {
          this_0.nb(full);
        }
      }
    }
    return this_0.toString();
  }
}
class Stream {
  constructor() {
    Stream_instance = this;
    this.b1m_1 = Regex.lh('\\s+');
  }
  i1m(str, collapseSpaces, processNamespaces) {
    return this.o1m(Companion_instance.a1i(str), collapseSpaces, processNamespaces);
  }
  o1m(r, collapseSpaces, processNamespaces) {
    return sequence(Xml$Stream$xmlSequence$slambda_0(r, collapseSpaces, processNamespaces));
  }
}
class Xml {
  constructor(type, name, attributes, allChildren, content) {
    this.n1l_1 = type;
    this.o1l_1 = name;
    this.p1l_1 = attributes;
    this.q1l_1 = allChildren;
    this.r1l_1 = content;
    this.s1l_1 = toCaseInsensitiveMap(this.p1l_1);
    var tmp = this;
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = this.o1l_1.toLowerCase();
    tmp.t1l_1 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  r1m() {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.q1l_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.io.serialization.xml.Xml.<get-allNodeChildren>.<anonymous>' call
      if (get_isNode(element)) {
        destination.h(element);
      }
    }
    return destination;
  }
  p1m() {
    var tmp;
    switch (this.n1l_1.k3_1) {
      case 0:
        tmp = joinToString_0(this.q1l_1, '', VOID, VOID, VOID, VOID, Xml$_get_text_$lambda_nsh6o);
        break;
      case 1:
        tmp = this.r1l_1;
        break;
      case 2:
        tmp = '';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  s1m() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList_1(this.p1l_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.serialization.xml.Xml.<get-attributesStr>.<anonymous>' call
      var tmp$ret$0 = ' ' + item.zk_1 + '="' + item.al_1 + '"';
      destination.h(tmp$ret$0);
    }
    return joinToString_0(destination, '');
  }
  q1m() {
    var tmp;
    switch (this.n1l_1.k3_1) {
      case 0:
        var tmp_0;
        if (this.q1l_1.g1()) {
          tmp_0 = '<' + this.o1l_1 + this.s1m() + '/>';
        } else {
          var children = joinToString_0(this.q1l_1, '', VOID, VOID, VOID, VOID, Xml$_get_outerXml_$lambda_n5rc6n);
          tmp_0 = '<' + this.o1l_1 + this.s1m() + '>' + children + '<\/' + this.o1l_1 + '>';
        }

        tmp = tmp_0;
        break;
      case 1:
        switch (this.o1l_1) {
          case '_text_':
            tmp = Entities_getInstance().m1m(this.r1l_1);
            break;
          case '_cdata_':
            tmp = '<![CDATA[' + this.r1l_1 + ']]>';
            break;
          case '_raw_':
            tmp = this.r1l_1;
            break;
          default:
            tmp = this.r1l_1;
            break;
        }

        break;
      case 2:
        tmp = '<!--' + this.r1l_1 + '-->';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  xh(name) {
    return this.t1m(name);
  }
  t1m(name) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.q1l_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.io.serialization.xml.Xml.children.<anonymous>' call
      if (equals_0(element.o1l_1, name, true)) {
        destination.h(element);
      }
    }
    return destination;
  }
  k10(name) {
    return this.s1l_1.d3(name);
  }
  u1m(name, defaultValue) {
    var tmp29_safe_receiver = this.s1l_1.d3(name);
    var tmp0_elvis_lhs = tmp29_safe_receiver == null ? null : toDoubleOrNull(tmp29_safe_receiver);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  v1m(name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? 0.0 : defaultValue;
    return $super === VOID ? this.u1m(name, defaultValue) : $super.u1m.call(this, name, defaultValue);
  }
  w1m(name, defaultValue) {
    var tmp31_safe_receiver = this.s1l_1.d3(name);
    var tmp;
    if (tmp31_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.toFloatOrNull' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = toDoubleOrNull(tmp31_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  x1m(name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? 0.0 : defaultValue;
    return $super === VOID ? this.w1m(name, defaultValue) : $super.w1m.call(this, name, defaultValue);
  }
  y1m(name, defaultValue) {
    var tmp32_safe_receiver = this.s1l_1.d3(name);
    var tmp0_elvis_lhs = tmp32_safe_receiver == null ? null : toIntOrNull_0(tmp32_safe_receiver);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  z1m(name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? 0 : defaultValue;
    return $super === VOID ? this.y1m(name, defaultValue) : $super.y1m.call(this, name, defaultValue);
  }
  a1n(name, defaultValue) {
    var tmp0_elvis_lhs = this.s1l_1.d3(name);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  b1n(name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? '' : defaultValue;
    return $super === VOID ? this.a1n(name, defaultValue) : $super.a1n.call(this, name, defaultValue);
  }
  c1n(name) {
    var tmp35_safe_receiver = this.s1l_1.d3(name);
    return tmp35_safe_receiver == null ? null : toDoubleOrNull(tmp35_safe_receiver);
  }
  d1n(name) {
    return this.s1l_1.d3(name);
  }
  toString() {
    return this.q1m();
  }
  e1n(type, name, attributes, allChildren, content) {
    return new Xml(type, name, attributes, allChildren, content);
  }
  u1l(type, name, attributes, allChildren, content, $super) {
    type = type === VOID ? this.n1l_1 : type;
    name = name === VOID ? this.o1l_1 : name;
    attributes = attributes === VOID ? this.p1l_1 : attributes;
    allChildren = allChildren === VOID ? this.q1l_1 : allChildren;
    content = content === VOID ? this.r1l_1 : content;
    return $super === VOID ? this.e1n(type, name, attributes, allChildren, content) : $super.e1n.call(this, type, name, attributes, allChildren, content);
  }
  hashCode() {
    var result = this.n1l_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o1l_1) | 0;
    result = imul(result, 31) + hashCode(this.p1l_1) | 0;
    result = imul(result, 31) + hashCode(this.q1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml))
      return false;
    var tmp0_other_with_cast = other instanceof Xml ? other : THROW_CCE();
    if (!this.n1l_1.equals(tmp0_other_with_cast.n1l_1))
      return false;
    if (!(this.o1l_1 === tmp0_other_with_cast.o1l_1))
      return false;
    if (!equals(this.p1l_1, tmp0_other_with_cast.p1l_1))
      return false;
    if (!equals(this.q1l_1, tmp0_other_with_cast.q1l_1))
      return false;
    if (!(this.r1l_1 === tmp0_other_with_cast.r1l_1))
      return false;
    return true;
  }
}
class CaseInsensitiveStringMap {
  static k1n(mapOrig, lcToOrig, mapLC) {
    var $this = createThis(this);
    $this.f1n_1 = mapOrig;
    $this.g1n_1 = lcToOrig;
    $this.h1n_1 = mapLC;
    return $this;
  }
  g1() {
    return this.f1n_1.g1();
  }
  m1() {
    return this.f1n_1.m1();
  }
  e3() {
    return this.f1n_1.e3();
  }
  i3() {
    return this.f1n_1.i3();
  }
  d1() {
    return this.f1n_1.d1();
  }
  static i1n() {
    return this.k1n(LinkedHashMap.ac(), LinkedHashMap.ac(), LinkedHashMap.ac());
  }
  n1j(key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = key.toLowerCase();
    return this.h1n_1.b3(tmp$ret$1);
  }
  b3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.n1j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  xh(key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = key.toLowerCase();
    return this.h1n_1.d3(tmp$ret$1);
  }
  d3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.xh((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  l1n(key, value) {
    this.k1j(key);
    // Inline function 'kotlin.collections.set' call
    this.f1n_1.f3(key, value);
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.g1n_1;
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var key_0 = key.toLowerCase();
    this_0.f3(key_0, key);
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = key.toLowerCase();
    return this.h1n_1.f3(tmp$ret$3, value);
  }
  f3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.l1n(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  j1n(from) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.m1().a1();
    while (_iterator__ex2g4s.b1()) {
      var v = _iterator__ex2g4s.c1();
      this.l1n(v.n1(), v.o1());
    }
  }
  h3(from) {
    return this.j1n(from);
  }
  k1j(key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var lkey = key.toLowerCase();
    var okey = this.g1n_1.d3(lkey);
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.f1n_1;
    (isInterface(this_0, KtMutableMap) ? this_0 : THROW_CCE()).g3(okey);
    var res = this.h1n_1.g3(lkey);
    this.g1n_1.g3(lkey);
    return res;
  }
  g3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.k1j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  equals(other) {
    var tmp;
    if (other instanceof CaseInsensitiveStringMap) {
      tmp = equals(this.h1n_1, other.h1n_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h1n_1);
  }
}
//endregion
function contentHashCode(_this__u8e3s4, $this, src, dst) {
  // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
var Companion_instance_1;
function Companion_getInstance() {
  if (Companion_instance_1 === VOID)
    new Companion();
  return Companion_instance_1;
}
function parseObject($this, s) {
  skipExpect_0(s, $this, _Char___init__impl__6a9atx(123));
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap.ac();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.serialization.json.Json.parseObject.<anonymous>' call
  obj: while (true) {
    var tmp5_subject = skipSpaces_0(s, $this).r1h();
    if (tmp5_subject === _Char___init__impl__6a9atx(125)) {
      s.s1h();
      break obj;
    } else if (tmp5_subject === _Char___init__impl__6a9atx(44)) {
      s.s1h();
      continue obj;
    }
    var tmp = $this.g1k(s);
    var key = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    skipExpect_0(skipSpaces_0(s, $this), $this, _Char___init__impl__6a9atx(58));
    var value = $this.g1k(s);
    // Inline function 'kotlin.collections.set' call
    this_0.f3(key, value);
  }
  return this_0;
}
function parseArray($this, s) {
  var out = null;
  var outNumber = null;
  skipExpect_0(s, $this, _Char___init__impl__6a9atx(91));
  array: while (true) {
    var tmp6_subject = skipSpaces_0(s, $this).r1h();
    if (tmp6_subject === _Char___init__impl__6a9atx(93)) {
      s.s1h();
      break array;
    } else if (tmp6_subject === _Char___init__impl__6a9atx(44)) {
      s.s1h();
      continue array;
    }
    var v = s.r1h();
    if (out == null && $this.j1k() && ((_Char___init__impl__6a9atx(48) <= v ? v <= _Char___init__impl__6a9atx(57) : false) || v === _Char___init__impl__6a9atx(45))) {
      if (outNumber == null) {
        outNumber = new MiniNumberArrayList();
      }
      outNumber.t1k(parseNumber($this, s));
    } else {
      if (out == null) {
        var tmp7_safe_receiver = outNumber;
        var tmp0_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.q1k_1;
        out = $this.k1k(tmp0_elvis_lhs == null ? 16 : tmp0_elvis_lhs);
      }
      if (!(outNumber == null)) {
        // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.fastForEach' call
        var this_0 = outNumber;
        var inductionVariable = 0;
        var last = this_0.q1k_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.io.serialization.json.Json.parseArray.<anonymous>' call
            var it = this_0.r1k_1[n];
            out.h(it);
          }
           while (inductionVariable < last);
        outNumber = null;
      }
      out.h($this.g1k(s));
    }
  }
  var tmp;
  if (outNumber == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.json.Json.parseArray.<anonymous>' call
    tmp = $this.m1k(outNumber);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? out : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? $this.l1k() : tmp2_elvis_lhs;
}
function parseNumber($this, s) {
  // Inline function 'korlibs.io.util.NumberParser.parseDouble' call
  NumberParser_getInstance();
  var out = 0.0;
  var frac = 1.0;
  var pointSeen = false;
  var eSeen = false;
  var negate = false;
  var negateExponent = false;
  var exponent = 0;
  var n = 0;
  $l$loop: while (true) {
    // Inline function 'korlibs.io.serialization.json.Json.parseNumber.<anonymous>' call
    n = n + 1 | 0;
    var c = s.r1h();
    var isC = Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(57)) <= 0 || c === _Char___init__impl__6a9atx(46) || c === _Char___init__impl__6a9atx(101) || c === _Char___init__impl__6a9atx(69) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(43);
    if (isC) {
      s.s1h();
    }
    var c_0 = isC ? c : _Char___init__impl__6a9atx(0);
    if (c_0 === _Char___init__impl__6a9atx(0))
      break $l$loop;
    if (c_0 === _Char___init__impl__6a9atx(101) || c_0 === _Char___init__impl__6a9atx(69))
      eSeen = true;
    else if (c_0 === _Char___init__impl__6a9atx(45)) {
      if (eSeen)
        negateExponent = true;
      else
        negate = true;
    } else if (c_0 === _Char___init__impl__6a9atx(46))
      pointSeen = true;
    else {
      if (eSeen) {
        exponent = imul(exponent, 10);
        exponent = exponent + ctypeAsInt(c_0) | 0;
      } else {
        if (pointSeen)
          frac = frac / 10;
        out = out * 10;
        out = out + ctypeAsInt(c_0);
      }
    }
  }
  var tmp = out * frac;
  // Inline function 'kotlin.math.pow' call
  var n_0 = negateExponent ? -exponent | 0 : exponent;
  var res = tmp * Math.pow(10.0, n_0);
  return negate ? -res : res;
}
function encodeString($this, str) {
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.serialization.json.Json.encodeString.<anonymous>' call
  encodeString_0($this, str, this_0);
  return this_0.toString();
}
function encodeString_0($this, str, b) {
  b.ob(_Char___init__impl__6a9atx(34));
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (c === _Char___init__impl__6a9atx(92))
      b.nb('\\\\');
    else if (c === _Char___init__impl__6a9atx(47))
      b.nb('\\/');
    else if (c === _Char___init__impl__6a9atx(39))
      b.nb("\\'");
    else if (c === _Char___init__impl__6a9atx(34))
      b.nb('\\"');
    else if (c === _Char___init__impl__6a9atx(8))
      b.nb('\\b');
    else if (c === _Char___init__impl__6a9atx(12))
      b.nb('\\f');
    else if (c === _Char___init__impl__6a9atx(10))
      b.nb('\\n');
    else if (c === _Char___init__impl__6a9atx(13))
      b.nb('\\r');
    else if (c === _Char___init__impl__6a9atx(9))
      b.nb('\\t');
    else
      b.ob(c);
  }
  b.ob(_Char___init__impl__6a9atx(34));
}
function invalidJson($this, msg) {
  throw IllegalArgumentException.l(msg);
}
function expect(_this__u8e3s4, $this, str) {
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = _this__u8e3s4.s1h();
      if (!(c === charSequenceGet(str, n)))
        throw IllegalStateException.s4("Expected '" + str + "' but found '" + toString(c) + "' at " + n);
    }
     while (inductionVariable <= last);
}
function skipSpaces_0(_this__u8e3s4, $this) {
  // Inline function 'korlibs.io.serialization.json.Json.skipWhile' call
  $l$loop: while (true) {
    var tmp;
    if (_this__u8e3s4.s1g()) {
      // Inline function 'korlibs.io.serialization.json.Json.skipSpaces.<anonymous>' call
      var it = _this__u8e3s4.r1h();
      tmp = isWhitespaceFast_0(it, $this);
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop;
    }
    _this__u8e3s4.s1h();
  }
  return _this__u8e3s4;
}
function skipExpect_0(_this__u8e3s4, $this, expected) {
  var readed = _this__u8e3s4.s1h();
  if (!(readed === expected))
    throw IllegalArgumentException.l("Expected '" + toString(expected) + "' but found '" + toString(readed) + "' at " + _this__u8e3s4.t1h());
}
function isWhitespaceFast_0(_this__u8e3s4, $this) {
  return _this__u8e3s4 === _Char___init__impl__6a9atx(32) || _this__u8e3s4 === _Char___init__impl__6a9atx(9) || _this__u8e3s4 === _Char___init__impl__6a9atx(13) || _this__u8e3s4 === _Char___init__impl__6a9atx(10);
}
function fromJson(_this__u8e3s4) {
  return Companion_getInstance().f1k(_this__u8e3s4);
}
function toJson(_this__u8e3s4, pretty) {
  pretty = pretty === VOID ? false : pretty;
  return Companion_getInstance().h1k(_this__u8e3s4, pretty);
}
function parse$level(stream) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var children = ArrayList.i1();
  var textNodes = 0;
  var endTag = null;
  loop: while (stream.b1()) {
    var tag = stream.c1();
    if (!(tag instanceof ProcessingInstructionTag)) {
      if (tag instanceof CommentTag)
        children.h(Companion_instance_3.m1l(tag.l1l_1));
      else {
        if (tag instanceof Text) {
          // Inline function 'kotlin.also' call
          children.h(tag.i1l_1 ? Companion_instance_3.k1l(tag.h1l_1) : Companion_instance_3.j1l(tag.h1l_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.io.serialization.xml.Companion.parse.level.<anonymous>' call
          textNodes = textNodes + 1 | 0;
        } else {
          if (tag instanceof OpenCloseTag) {
            var tmp = Companion_instance_3;
            // Inline function 'kotlin.collections.listOf' call
            var tmp$ret$2 = emptyList();
            children.h(tmp.g1l(tag.a1l_1, tag.b1l_1, tmp$ret$2));
          } else {
            if (tag instanceof OpenTag) {
              var out = parse$level(stream);
              var tmp17_safe_receiver = out.w1k_1;
              var tmp18_safe_receiver = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.x1k_1;
              if (!((tmp18_safe_receiver == null ? null : equals_0(tmp18_safe_receiver, tag.y1k_1, true)) === true)) {
                var tmp16_safe_receiver = out.w1k_1;
                throw IllegalArgumentException.l("Expected '" + tag.y1k_1 + "' but was " + (tmp16_safe_receiver == null ? null : tmp16_safe_receiver.x1k_1));
              }
              children.h(new Xml(Type_NODE_getInstance(), tag.y1k_1, tag.z1k_1, out.v1k_1, ''));
            } else {
              if (tag instanceof CloseTag) {
                endTag = tag;
                break loop;
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
  }
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(children, 10));
  var index = 0;
  var tmp0_iterator = children.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.io.serialization.xml.Companion.parse.level.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var i = checkIndexOverflow(tmp1);
    var tmp_0;
    if (item.n1l_1.equals(Type_TEXT_getInstance())) {
      var firstText = i === 0;
      var lastText = i === (children.d1() - 1 | 0);
      var tmp_1;
      if (firstText && lastText) {
        // Inline function 'kotlin.text.trim' call
        var this_0 = item.r1l_1;
        var tmp$ret$3 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        tmp_1 = item.u1l(VOID, VOID, VOID, VOID, tmp$ret$3);
      } else if (firstText) {
        // Inline function 'kotlin.text.trimStart' call
        var this_1 = item.r1l_1;
        var tmp$ret$4 = toString_0(trimStart(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        tmp_1 = item.u1l(VOID, VOID, VOID, VOID, tmp$ret$4);
      } else if (lastText) {
        // Inline function 'kotlin.text.trimEnd' call
        var this_2 = item.r1l_1;
        var tmp$ret$5 = toString_0(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
        tmp_1 = item.u1l(VOID, VOID, VOID, VOID, tmp$ret$5);
      } else {
        tmp_1 = item;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = item;
    }
    var tmp$ret$6 = tmp_0;
    destination.h(tmp$ret$6);
  }
  return new Xml$Companion$parse$Level(destination, endTag);
}
var Type_NODE_instance;
var Type_TEXT_instance;
var Type_COMMENT_instance;
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NODE_instance = new Type('NODE', 0);
  Type_TEXT_instance = new Type('TEXT', 1);
  Type_COMMENT_instance = new Type('COMMENT', 2);
}
var Companion_instance_2;
function Companion_getInstance_0() {
  return Companion_instance_2;
}
function *_generator_invoke__zhh2q8($this, $this$sequence, $completion) {
  var sb = StringBuilder.sb(128);
  loop: while (!get_eof($this.y1l_1)) {
    var str = readUntilBuilder($this.y1l_1, _Char___init__impl__6a9atx(60), sb.xg(), false);
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(str) > 0) {
      var text = str.toString();
      var tmp;
      if ($this.z1l_1) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.text.replace' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.io.serialization.xml.Stream.xmlSequence.<anonymous>.<anonymous>' call
        var it = Stream_getInstance().b1m_1.ph(text, ' ');
        var tmp_0;
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.text.all' call
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(it)) {
            var element = charSequenceGet(it, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.io.serialization.xml.Stream.xmlSequence.<anonymous>.<anonymous>.<anonymous>' call
            if (!isWhitespaceFast(element)) {
              tmp$ret$3 = false;
              break $l$block;
            }
          }
          tmp$ret$3 = true;
        }
        if (tmp$ret$3) {
          tmp_0 = '';
        } else {
          tmp_0 = it;
        }
        tmp = tmp_0;
      } else {
        tmp = text;
      }
      var textNs = tmp;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(textNs) > 0) {
        var tmp_1 = $this$sequence.hl(new Text(Entities_getInstance().f1m(textNs)), $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
      }
    }
    if (get_eof($this.y1l_1))
      break loop;
    skipExpect($this.y1l_1, _Char___init__impl__6a9atx(60));
    skipSpaces($this.y1l_1);
    sb.xg();
    var processingInstruction = tryExpect($this.y1l_1, _Char___init__impl__6a9atx(63));
    var processingEntityOrDocType = tryExpect($this.y1l_1, _Char___init__impl__6a9atx(33));
    if (processingEntityOrDocType) {
      sb.ob(_Char___init__impl__6a9atx(33));
      $l$loop: while (!get_eof($this.y1l_1)) {
        var c = $this.y1l_1.r1h();
        if (c === _Char___init__impl__6a9atx(62) || isWhitespaceFast(c) || c === _Char___init__impl__6a9atx(47))
          break $l$loop;
        sb.ob($this.y1l_1.s1h());
        if (startsWith(sb, '!--')) {
          sb.xg();
          $l$loop_0: while (!get_eof($this.y1l_1)) {
            sb.ob($this.y1l_1.s1h());
            if (endsWith(sb, '-->')) {
              sb.zg(sb.a() - 3 | 0, sb.a());
              break $l$loop_0;
            }
          }
          var tmp_2 = $this$sequence.hl(new CommentTag(sb.toString()), $completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
          continue loop;
        }
        if (startsWith(sb, '![CDATA[')) {
          sb.xg();
          $l$loop_1: while (!get_eof($this.y1l_1)) {
            sb.ob($this.y1l_1.s1h());
            if (endsWith(sb, ']]>')) {
              sb.zg(sb.a() - 3 | 0, sb.a());
              break $l$loop_1;
            }
          }
          // Inline function 'kotlin.also' call
          var this_0 = new Text(sb.toString());
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.io.serialization.xml.Stream.xmlSequence.<anonymous>.<anonymous>' call
          this_0.i1l_1 = true;
          var tmp_3 = $this$sequence.hl(this_0, $completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          continue loop;
        }
      }
      sb.yg(0);
    }
    var close = tryExpect($this.y1l_1, _Char___init__impl__6a9atx(47)) || processingEntityOrDocType;
    skipSpaces($this.y1l_1);
    // Inline function 'kotlin.takeIf' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_4;
    // Inline function 'korlibs.io.serialization.xml.Stream.xmlSequence.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(sb) > 0) {
      tmp_4 = sb;
    } else {
      tmp_4 = null;
    }
    var tmp43_safe_receiver = tmp_4;
    var tmp0_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.toString();
    var tmp_5;
    if (tmp0_elvis_lhs == null) {
      var tmp44_safe_receiver = matchIdentifier($this.y1l_1, sb.xg());
      tmp_5 = tmp44_safe_receiver == null ? null : tmp44_safe_receiver.toString();
    } else {
      tmp_5 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_5;
    var tmp_6;
    if (tmp1_elvis_lhs == null) {
      var message = "Couldn't match identifier after '<', offset=" + $this.y1l_1.t1h() + ", near='" + $this.y1l_1.y1h() + "'";
      throw IllegalStateException.s4(toString_0(message));
    } else {
      tmp_6 = tmp1_elvis_lhs;
    }
    var name = tmp_6;
    skipSpaces($this.y1l_1);
    // Inline function 'kotlin.collections.linkedMapOf' call
    var attributes = LinkedHashMap.ac();
    while (!($this.y1l_1.r1h() === _Char___init__impl__6a9atx(63)) && !($this.y1l_1.r1h() === _Char___init__impl__6a9atx(47)) && !($this.y1l_1.r1h() === _Char___init__impl__6a9atx(62))) {
      var tmp45_safe_receiver = matchStringOrId($this.y1l_1, Stream_getInstance(), sb.xg());
      var tmp2_elvis_lhs = tmp45_safe_receiver == null ? null : tmp45_safe_receiver.toString();
      var tmp_7;
      if (tmp2_elvis_lhs == null) {
        throw IllegalArgumentException.l('Malformed document or unsupported xml construct around ~' + $this.y1l_1.y1h() + "~ for name '" + name + "'");
      } else {
        tmp_7 = tmp2_elvis_lhs;
      }
      var key = tmp_7;
      skipSpaces($this.y1l_1);
      if (tryExpect($this.y1l_1, _Char___init__impl__6a9atx(61))) {
        skipSpaces($this.y1l_1);
        var tmp46_safe_receiver = matchStringOrId($this.y1l_1, Stream_getInstance(), sb.xg());
        var argsQuote = tmp46_safe_receiver == null ? null : tmp46_safe_receiver.toString();
        // Inline function 'kotlin.collections.set' call
        var tmp_8;
        if (!(argsQuote == null) && !(startsWith_0(argsQuote, "'") || startsWith_0(argsQuote, '"'))) {
          tmp_8 = argsQuote;
        } else if (!(argsQuote == null)) {
          var tmp_9 = Entities_getInstance();
          // Inline function 'kotlin.text.substring' call
          var endIndex = argsQuote.length - 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$13 = argsQuote.substring(1, endIndex);
          tmp_8 = tmp_9.f1m(tmp$ret$13);
        } else {
          tmp_8 = Entities_getInstance().f1m(ensureNotNull(matchIdentifier($this.y1l_1, sb.xg())).toString());
        }
        var value = tmp_8;
        attributes.f3(key, value);
      } else {
        // Inline function 'kotlin.collections.set' call
        attributes.f3(key, key);
      }
      skipSpaces($this.y1l_1);
    }
    var openclose = tryExpect($this.y1l_1, _Char___init__impl__6a9atx(47));
    var processingInstructionEnd = tryExpect($this.y1l_1, _Char___init__impl__6a9atx(63));
    skipExpect($this.y1l_1, _Char___init__impl__6a9atx(62));
    var tmp_10;
    if (!$this.a1m_1 && contains(name, _Char___init__impl__6a9atx(58))) {
      tmp_10 = substringAfter(name, _Char___init__impl__6a9atx(58));
    } else {
      tmp_10 = name;
    }
    var elementName = tmp_10;
    var tmp_11 = $this$sequence.hl(processingInstruction || processingEntityOrDocType ? new ProcessingInstructionTag(elementName, attributes) : openclose ? new OpenCloseTag(elementName, attributes) : close ? new CloseTag(elementName) : new OpenTag(elementName, attributes), $completion);
    if (tmp_11 === get_COROUTINE_SUSPENDED())
      tmp_11 = yield tmp_11;
  }
  return Unit_instance;
}
function matchStringOrId(_this__u8e3s4, $this, out) {
  var tmp0_elvis_lhs = matchSingleOrDoubleQuoteString(_this__u8e3s4, out);
  return tmp0_elvis_lhs == null ? matchIdentifier(_this__u8e3s4, out) : tmp0_elvis_lhs;
}
function Xml$Stream$xmlSequence$slambda_0($r, $collapseSpaces, $processNamespaces) {
  var i = new Xml$Stream$xmlSequence$slambda($r, $collapseSpaces, $processNamespaces);
  var l = function ($this$sequence, $completion) {
    return i.g1m($this$sequence, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_3;
function Companion_getInstance_1() {
  return Companion_instance_3;
}
var Entities_instance;
function Entities_getInstance() {
  if (Entities_instance === VOID)
    new Entities();
  return Entities_instance;
}
var Stream_instance;
function Stream_getInstance() {
  if (Stream_instance === VOID)
    new Stream();
  return Stream_instance;
}
function Xml$_get_text_$lambda_nsh6o(it) {
  return it.p1m();
}
function Xml$_get_outerXml_$lambda_n5rc6n(it) {
  return it.q1m();
}
function Type_NODE_getInstance() {
  Type_initEntries();
  return Type_NODE_instance;
}
function Type_TEXT_getInstance() {
  Type_initEntries();
  return Type_TEXT_instance;
}
function Type_COMMENT_getInstance() {
  Type_initEntries();
  return Type_COMMENT_instance;
}
function Xml_0(str, collapseSpaces, processNamespaces) {
  collapseSpaces = collapseSpaces === VOID ? true : collapseSpaces;
  processNamespaces = processNamespaces === VOID ? false : processNamespaces;
  return Companion_instance_3.h1m(str, collapseSpaces, processNamespaces);
}
function toCaseInsensitiveMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = CaseInsensitiveStringMap.i1n();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.serialization.xml.toCaseInsensitiveMap.<anonymous>' call
  this_0.j1n(_this__u8e3s4);
  return this_0;
}
function get_isNode(_this__u8e3s4) {
  return _this__u8e3s4.n1l_1.equals(Type_NODE_getInstance());
}
function flip(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(_this__u8e3s4.d1());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = _this__u8e3s4.m1().a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.io.serialization.xml.flip.<anonymous>' call
    var tmp$ret$1 = new Pair(item.o1(), item.n1());
    destination.h(tmp$ret$1);
  }
  return toMap(destination);
}
function get(_this__u8e3s4, name) {
  return children(_this__u8e3s4, name);
}
function children(_this__u8e3s4, name) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.i1();
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.io.serialization.xml.children.<anonymous>' call
    var list = element.t1m(name);
    addAll(destination, list);
  }
  return destination;
}
//region block: post-declaration
initMetadataForClass(Json, 'Json', Json);
initMetadataForCompanion(Companion);
protoOf(MiniNumberArrayList).s1i = getAt;
protoOf(MiniNumberArrayList).u2 = listIterator;
protoOf(MiniNumberArrayList).v2 = listIterator_0;
protoOf(MiniNumberArrayList).w2 = subList;
protoOf(MiniNumberArrayList).v1i = contains_0;
protoOf(MiniNumberArrayList).w1i = containsAll;
protoOf(MiniNumberArrayList).g1 = isEmpty;
protoOf(MiniNumberArrayList).a1 = iterator;
initMetadataForClass(MiniNumberArrayList, 'MiniNumberArrayList', MiniNumberArrayList, VOID, [DoubleList]);
initMetadataForInterface(CustomSerializer, 'CustomSerializer');
initMetadataForClass(Xml$Companion$parse$Level, 'Level');
initMetadataForCompanion(Companion_0);
initMetadataForClass(Element, 'Element');
initMetadataForClass(ProcessingInstructionTag, 'ProcessingInstructionTag');
initMetadataForClass(OpenCloseTag, 'OpenCloseTag');
initMetadataForClass(OpenTag, 'OpenTag');
initMetadataForClass(CommentTag, 'CommentTag');
initMetadataForClass(CloseTag, 'CloseTag');
initMetadataForClass(Text, 'Text');
initMetadataForLambda(Xml$Stream$xmlSequence$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Type, 'Type');
initMetadataForClass(Literals, 'Literals');
initMetadataForObject(Entities, 'Entities');
initMetadataForObject(Stream, 'Stream');
initMetadataForClass(Xml, 'Xml');
initMetadataForClass(CaseInsensitiveStringMap, 'CaseInsensitiveStringMap', CaseInsensitiveStringMap.i1n, VOID, [KtMutableMap]);
//endregion
//region block: init
Companion_instance_2 = new Companion_0();
Companion_instance_3 = new Companion_1();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance345a0ojzj45ct,
  fromJson as fromJson1zzawiiassmu2,
  toJson as toJsonn1f4824lp9qj,
  Xml_0 as Xmlepssdknidwxh,
  get as get12f8xnsftqcwn,
};
//endregion
